
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { AuthService } from './auth.service';
import { ConfigurationService } from './configuration.service';

@Injectable()
export class ContractFileService {

    private _authService: AuthService;

    constructor(private http: HttpClient, private injector: Injector) { }

    private get authService() {
        if (!this._authService)
            this._authService = this.injector.get(AuthService);

        return this._authService;
    }

    getAllByFacility(facilityTypeId: number, contractId: number) {
        return this.http.get('api/ContractFile/' + facilityTypeId + '/' + contractId, this.getAuthHeader(true));
    }

    removeById(id: number, contractId: number, fileName: string, fileNameInternal: string) {
        return this.http.get(`api/ContractFile/RemoveById/${id}/${contractId}/${fileName}/${fileNameInternal}`, this.getAuthHeader(true));
    }

    delete(id: number) {
        return this.http.get('api/ContractFile/Delete/' + id, this.getAuthHeader(true));
    }

    viewFile(facilityTypeId: number, contractId: number, contractFileId: number) {
        return this.http.get(`/api/ContractFile/DownloadPdf/${facilityTypeId}/${contractId}/${contractFileId}`, {
            responseType: 'blob',
            headers: new HttpHeaders()
                .append('Authorization', 'Bearer ' + this.authService.accessToken)
                .append('Content-Type', 'application/json')
        });
    }

    public getAuthHeader(includeJsonContentType?: boolean) {
        let headers = new HttpHeaders({ 'Authorization': 'Bearer ' + this.authService.accessToken });

        if (includeJsonContentType)
            headers.append("Content-Type", "application/json");

        headers.append("Accept", 'application/json');
        headers.append("App-Version", ConfigurationService.appVersion);

        var options = {
            headers: headers
        };

        return options;
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/contract-file.service.ts